export default __webpack_public_path__ + "static/media/floor.27249fc2.jpg";